<template>
  <div class="login-container">
    <div class="login-form-wrapper">
      <div class="login-logo">
        <img src="/logo.png" alt="Logo" class="logo-image" />
        <h2 class="logo-text">中政量化研究院</h2>
      </div>
      <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-width="0px" class="login-form">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="用户名" prefix-icon="el-icon-user" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码" prefix-icon="el-icon-lock" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" class="login-button">登录</el-button>
        </el-form-item>
        <div class="login-footer">
          <span>还没有账号？</span>
          <a href="javascript:void(0)" @click="$router.push('/register')">立即注册</a>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { authAPI } from '../services/api';

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false
    };
  },
  methods: {
    async handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          try {
            // 调用登录API
            const data = await authAPI.login(this.loginForm);
            if (data.success) {
              // 登录成功，存储token
              localStorage.setItem('token', data.token);
              this.$message.success('登录成功');
              
              // 获取用户信息，根据角色决定跳转页面
              const userData = await authAPI.getCurrentUser();
              if (userData.success) {
                const user = userData.data;
                const roles = user.roles || [];
                const roleNames = roles.map(role => role.name);
                
                // 检查是否有redirect参数，如果有，优先使用
                if (this.$route.query.redirect) {
                  this.$router.push(this.$route.query.redirect);
                } else {
                  // 管理员或编辑角色跳转到管理后台
                  if (roleNames.includes('admin') || roleNames.includes('editor')) {
                    this.$router.push('/admin');
                  } else {
                    // 读者角色跳转到网站首页
                    this.$router.push('/');
                  }
                }
              } else {
                // 获取用户信息失败，默认跳转到首页
                this.$router.push('/');
              }
            } else {
              // 显示后端返回的具体错误信息
              this.$message.error(data.message || '登录失败');
            }
          } catch (error) {
            console.error('登录请求失败:', error);
            this.$message.error('网络错误，请检查网络连接或稍后重试');
          } finally {
            this.loading = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.login-container {
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-form-wrapper {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.login-logo {
  text-align: center;
  margin-bottom: 30px;
}

.logo-image {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.logo-text {
  color: #304156;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
}

.login-form {
  width: 100%;
}

.login-button {
  width: 100%;
  height: 40px;
  font-size: 16px;
}

.login-footer {
  text-align: center;
  margin-top: 20px;
  color: #909399;
  font-size: 14px;
}

.login-footer a {
  color: #409eff;
  text-decoration: none;
  margin-left: 5px;
}

.login-footer a:hover {
  text-decoration: underline;
}
</style>